import { render, staticRenderFns } from "./NewPlantModal.vue?vue&type=template&id=64d418e7&"
import script from "./NewPlantModal.vue?vue&type=script&lang=js&"
export * from "./NewPlantModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports